<template>
  <div>
    <RoomProvider></RoomProvider>
    <h2>Rekisteröitymiskoodin luonti</h2>
    <form v-if="rooms" @submit.prevent="onSubmit()">
      <fieldset>
        <legend>Valitse sallitut huoneet:</legend>
        <div class="line" v-for="room in rooms" :key="room.id">
          <label :for="uniqueId(room)">{{room.name}}</label>
          <div class="checkbox-wrap">
            <input type="checkbox" :id="uniqueId(room)" :value="room.id" v-model="selectedRooms">
          </div>
        </div>
      </fieldset>
      <hr>
      <fieldset>
        <legend>Luotavien koodien määrä: 1-10</legend>
        <div class="line">
          <input v-model="amount" type="number" value="1">
          <button type="submit">Luo koodit</button>
        </div>
      </fieldset>
    </form>
    <div v-else>Ladataan...</div>

    <span v-if="isLoadingCodes">Luodaan koodeja...</span>
    <table v-else>
      <tr>
        <th>Koodi</th>
        <th>Linkki</th>
      </tr>
      <tr v-for="code in codes" :key="code">
        <td>{{code}}</td>
        <td>https://varaus.sandbox.fi/register?code={{code}}</td>
      </tr>
    </table>
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

import RoomProvider from '@/components/providers/RoomProvider';
import Room from './../store/modules/room/types';
import Auth from './../store/modules/auth/types';

export default {
  name: 'CodeGenerateView',
  components: { RoomProvider },
  data () {
    return {
      selectedRooms: [],
      amount: 1,
    }
  },
  computed: {
    codes () {
      return this.getCodes();
    },
    isLoadingCodes () {
      return this.getCodesStatus() === 'pending';
    },
    rooms () {
      return this.getRooms();
    },
    ...mapGetters('Room', [Room.getters.GET_ROOMS]),
    ...mapGetters('Auth', [Auth.getters.GET_CODES]),
    ...mapGetters('Auth', [Auth.getters.GET_CODES_STATUS]),
  },
  methods: {
    uniqueId (room) {
      return `code-generate-room-${room.id}`;
    },
    onSubmit () {
      console.log('onSubmit');
      const amount = this.amount;
      const permissions = this.selectedRooms.sort();
      this.generateCodes({amount, permissions});
    },
    ...mapActions('Auth', [Auth.actions.GENERATE_CODES])
  },
}
</script>

<style lang="scss" scoped>
  @import 'src/color.scss';

  form {
    text-align: left;
    width: 80%;
    margin: 1em auto;
  }

  fieldset {
    border: none;
    padding: 0;
    margin-bottom: 1em;

    legend {
      margin-bottom: 1em;
    }
  }

  input, label {
    box-sizing: border-box;
    cursor: pointer;
  }

  .line {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  label {
    flex: 1;
    display: inline-block;
    font-weight: bold;
    text-align: right;
  }

  input[type='checkbox'] {
  }

  .checkbox-wrap {
    flex: 1;
    padding-left: 2%;
    text-align: left;
    display: inline-block;

  }
  table {
    width: 60%;
    margin: 2rem auto;
    th, td {
      padding: 0.5rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/CodeGenerateView.vue